import axios from "axios";

export const fetchGetAvailableTasks = async (data: any) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;

  return axios.post(`${baseTaskUrl}/TaskTemplate/get-list-task-template`, data);
};
